import { render, staticRenderFns } from "./add-socks-regular.vue?vue&type=template&id=01615365&"
import script from "./add-socks-regular.vue?vue&type=script&lang=js&"
export * from "./add-socks-regular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports